'use strict';

import SearchRoutePoint from './SearchRoutePoint';
import SearchRouteTime from './SearchRouteTime';

export default class SearchRoute extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {index, dateRange} = this.props;
        const that = this;

        this.dateEl = $(`.routeDate${index}`);

        let days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        if(window.locale === 'ru') {
            days = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
            months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
            monthsShort = ["Янв", "Фев", "Март", "Апр", "Май", "Июн", "Июл", "Авг", "Сент", "Окт", "Ноя", "Дек"];
        }

        if(dateRange) {
            this.dateEl.daterangepicker({
                opens: "center",
                autoApply: true,
                autoUpdateInput: false,
                minDate: moment(),
                locale: {
                    firstDay: 1,
                    customRangeLabel: "Custom",
                    daysOfWeek: days,
                    monthNames: months,
                }
            }, function(startDate, endDate) {
                let date = startDate.format('DD.MM.YYYY');
                if(date !== endDate.format('DD.MM.YYYY')) date += ' - ' + endDate.format('DD.MM.YYYY')
                that.changeDate(date);
            })
        } else {
            this.dateEl.datepickerM({
                autoHide: true,
                weekStart: 1,
                offset: 0,
                startDate: moment(),
                format: "dd.mm.yyyy",
                daysMin: days,
                months: months,
                monthsShort: monthsShort,
                pick: () => {
                    const date = $(`.routeDate${index}`).datepickerM('getDate', true);
                    this.changeDate(date);
                }
            });
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.route.date !== this.dateEl.val()) {
            this.dateEl.val(this.props.route.date);
        }
    }

    changePoint(direction, point) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route[direction] = point;
        onChangeRoute(index, route)
    }

    changeDate(date) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route.date = date;
        onChangeRoute(index, route)
    }

    changeTime(time) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route.time = time;
        onChangeRoute(index, route)
    }

    changeSeats(e, direction) {
        e.preventDefault();
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        let seats = route.seats;
        if(direction === 'down') {
            seats = seats > 0 ? seats - 1 : seats;
        } else {
            seats++;
        }
        route.seats = seats;
        onChangeRoute(index, route)
    }

    swapRoute() {
        const {index, onChangeRoute} = this.props;
        let route = {
            ...this.props.route,
            from: this.props.route.to,
            to: this.props.route.from,
        };
        onChangeRoute(index, route)
    }

    render() {
        const {type, index, route, errors, airports, onRemove, onSearch, dateRange} = this.props;

        const showTime = ['planes', 'plane', 'sharing'].includes(type);
        const showSeats = ['planes', 'plane'].includes(type);

        return <div className="search-group">
            {index > 0 && <a href='#' className="search-group__remove" onClick={e => onRemove(e, index)}/>}
            <div className="search-row">
                <div className="search-col" style={{flex: 1}}>
                    <SearchRoutePoint
                        index={index}
                        label={tMsg('Откуда')}
                        direction={'from'}
                        airports={airports}
                        point={route.from}
                        error={errors.includes('from')}
                        onSelect={point => this.changePoint('from', point)}
                    />
                    {route.from.id && route.to.id && <a className="direction-switch" onClick={() => this.swapRoute()}>
                        <i className="icon-arrow"/>
                    </a>}
                </div>
                <div className="search-col" style={{flex: 1}}>
                    <SearchRoutePoint
                        index={index}
                        label={tMsg('Куда')}
                        direction={'to'}
                        airports={airports}
                        point={route.to}
                        error={errors.includes('to')}
                        onSelect={point => this.changePoint('to', point)}
                    />
                </div>
                <div className="search-col">
                    <div className={clsx('search-inputbox search-date',  {error: errors.includes('date')})}>
                        <input
                            type="text"
                            placeholder={dateRange ? tMsg('Дата / интервал') : tMsg('Дата')}
                            className={`routeDate${index}`}
                            defaultValue={route.date}
                            onFocus={e => $(e.target).select()}
                            onChange={e => {if(e.target.value.trim() === '') this.changeDate('')}}
                        />
                    </div>
                </div>
                {showTime && <div className="search-col">
                    <SearchRouteTime
                        index={index}
                        value={route.time}
                        error={errors.includes('time')}
                        onSelect={time => this.changeTime(time)}
                    />
                </div>}
                {showSeats && <div className="search-col">
                    <div className={clsx('search-inputbox search-count', {error: errors.includes('seats')})}>
                        <div className={clsx('search-spinner', {changed: route.seats > 0})}>
                            <i className="icon-people"></i>
                            <input type="text" className="search-spinner__input" value={route.seats} readOnly/>
                            <a href='#' className="search-spinner__down" onClick={e => this.changeSeats(e, 'down')}></a>
                            <a href='#' className="search-spinner__up" onClick={e => this.changeSeats(e, 'up')}></a>
                        </div>
                    </div>
                </div>}
                {type === 'seats' && <button className="search-button button-search" onClick={() => onSearch()}>{tMsg('Поиск')}</button>}
            </div>
            {!showTime && <SearchRouteTime
                index={index}
                value={route.time}
                error={errors.includes('time')}
                onSelect={time => this.changeTime(time)}
                hidden={true}
            />}
        </div>
    }
}